export default __webpack_public_path__ + "static/media/art_1.bb65edf4.mp4";